/** Maps console ops page id → BaaS GET …/limits item id. */
export const BAAS_STABLES_OPERATION_LIMIT_IDS = {
  buy: "compra",
  sell: "venda",
  swap: "swap",
  withdraw: "saque-onchain",
};

export const BAAS_STABLES_LIMIT_PERIODS = ["hourly", "daily", "monthly"];

const OP_META = [
  {
    operationType: "purchase",
    limitId: "compra",
    labelKey: "baas.stablesWallet.limits.ops.buy",
    descriptionKey: "baas.stablesWallet.limits.ops.buyHint",
  },
  {
    operationType: "sale",
    limitId: "venda",
    labelKey: "baas.stablesWallet.limits.ops.sell",
    descriptionKey: "baas.stablesWallet.limits.ops.sellHint",
  },
  {
    operationType: "conversion",
    limitId: "swap",
    labelKey: "baas.stablesWallet.limits.ops.swap",
    descriptionKey: "baas.stablesWallet.limits.ops.swapHint",
  },
  {
    operationType: "withdrawal",
    limitId: "saque-onchain",
    labelKey: "baas.stablesWallet.limits.ops.withdraw",
    descriptionKey: "baas.stablesWallet.limits.ops.withdrawHint",
  },
];

/**
 * Editable account policies — daily by default (America/Sao_Paulo; matches Baas defaults).
 * Soft-replace PUT should round-trip these keys.
 */
export const BAAS_STABLES_LIMIT_POLICY_TEMPLATES = OP_META.flatMap((op) =>
  ["daily", "monthly"].map((periodType) => ({
    key: `${op.operationType}-${periodType}`,
    operationType: op.operationType,
    periodType,
    limitId: op.limitId,
    labelKey: op.labelKey,
    descriptionKey: op.descriptionKey,
  })),
);

export const policyDraftKey = (operationType, periodType) =>
  `${String(operationType || "").toLowerCase()}-${String(periodType || "").toLowerCase()}`;

export const getBaasStablesLimitItemForOperation = (limits, operation) => {
  const limitId = BAAS_STABLES_OPERATION_LIMIT_IDS[operation];
  if (!limitId) return null;

  const items = Array.isArray(limits?.items) ? limits.items : [];
  const match = items.find((item) => item.id === limitId);
  if (match) return match;

  if (operation === "withdraw" && limits?.withdrawOnchain) {
    const used = Number(limits.withdrawOnchain.used ?? 0);
    const max = Number(limits.withdrawOnchain.max ?? 0);
    return {
      ...limits.withdrawOnchain,
      used,
      max,
      availableCents: Math.max(0, max - used),
      usage: Array.isArray(limits.withdrawOnchain.usage)
        ? limits.withdrawOnchain.usage
        : [],
    };
  }

  return {
    id: limitId,
    label: limitId,
    description: "",
    used: 0,
    max: 0,
    availableCents: 0,
    usage: [],
  };
};

/** Compra limit disponível in centavos from mapped BaaS entityLimits. */
export const resolveBaasBuyLimitAvailableCents = (limits) => {
  const item = getBaasStablesLimitItemForOperation(limits, "buy");
  if (!item) return 0;
  if (item.availableCents != null && Number.isFinite(Number(item.availableCents))) {
    return Math.max(0, Math.round(Number(item.availableCents)));
  }
  return Math.max(0, Math.round(Number(item.max ?? 0) - Number(item.used ?? 0)));
};

/** Whether entityLimits includes a configured compra policy. */
export const isBaasBuyLimitConfigured = (limits) => {
  const item = getBaasStablesLimitItemForOperation(limits, "buy");
  if (!item) return false;
  return Number(item.max ?? 0) > 0 || Number(item.availableCents ?? 0) > 0;
};
